const playlistModule = {
  state: {
    tuneLimit: 25
  },
  mutations: {},
  actions: {},
  getters: {
    getTuneLimit (state) {
      return state.tuneLimit
    }
  }
}
export default playlistModule



// WEBPACK FOOTER //
// ./src/store/PlaylistModule.js